<div id="app-community-topicsd" class="container d-flex flex-column flex-grow-1 mt-5 pt-4 pb-4 h-100" role="main"
    [attr.aria-label]="('COMMUNITY' | translate)">
    <app-headline [type]="'h4'" [class]="'text-muted fw-bold mb-2'" [title]="('COMMUNITY' | translate)"></app-headline>
    <ng-container *ngIf="!(loadingService.loadingIndicator$ | async)">
        <!-- IF NO SUBCOMMUNITY OR TOPIC -->
        <div *ngIf="true" class="card mb-3">
            <div class="card-body p-0">
                <div class="card border-0 box-shadow-bottom">
                    <div class="card-body text-center p-4">
                        <div class="my-3">
                            <div
                                class="no-content-large-icon bg-warning rounded-circle d-flex justify-content-center align-items-center mx-auto">
                                <app-icon-badge [style]="'noContent'" [icon]="'topic'"></app-icon-badge>
                            </div>
                            <app-headline [type]="'h5'" [class]="'card-title mt-3'"
                                [title]="'COMMUNITYNOTOPICS' | translate"></app-headline>
                        </div>

                        <div
                            class="fade-card d-flex align-items-center gap-2 p-2 mt-5 rounded-3 shadow-sm bg-light border flex-wrap">
                            <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-5'"
                                [fontColor]="'text-warning'"></app-icon-badge>
                            <div class="d-flex flex-column text-start flex-grow-1">
                                <app-headline [type]="'h6'" [class]="'fw-bold text-muted'"
                                    [title]="'COMMUNITYCREATETOPICTITLE' | translate"></app-headline>
                                <app-content [fontSize]="'fs-default'">{{ 'COMMUNITYSTARTYOURFIRSTTOPICNOW' | translate
                                    }}</app-content>
                            </div>
                            <div class="d-flex justify-content-end w-only-sm-100">
                                <app-form-button [text]="'START' | translate"
                                    (click)="onOpenDialog($event, 'show-newtopicdialog')"
                                    [cssClass]="'e-primary fw-semibold'"></app-form-button>
                            </div>
                        </div>

                        <div
                            class="fade-card d-flex align-items-center gap-2 p-2 mt-3 rounded-3 shadow-sm bg-light border flex-wrap">
                            <app-icon-badge [style]="'default'" [icon]="'forum'" [fontSize]="'fs-5'"
                                [fontColor]="'text-warning'"></app-icon-badge>
                            <div class="d-flex flex-column text-start flex-grow-1">
                                <app-headline [type]="'h6'" [class]="'fw-bold text-muted'"
                                    [title]="'COMMUNITYCREATESUBCOMMUNITYTITLE' | translate"></app-headline>
                                <app-content [fontSize]="'fs-default'">{{ 'COMMUNITYSTARTASUBCOMMUNITYNOW' | translate
                                    }}</app-content>
                            </div>
                            <div class="d-flex justify-content-end w-only-sm-100">
                                <app-form-button [text]="'START' | translate" (click)="true"
                                    [cssClass]="'e-primary fw-semibold'"></app-form-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="card mb-3">
        <div class="card-body">
            <!-- Search Bar -->
            <div class="d-flex align-items-center gap-2">
                <div class="flex-grow-1">
                    <app-form-input [type]="'search'" [hasErrorField]="false"
                        [placeholder]="('COMMUNITYSSEARCHPLACEHOLDER' | translate)" [iconFront]="'search'"
                        [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'searchString'"
                        [fG]="communityTopicForm"></app-form-input>
                </div>
                <app-form-dropdown [fG]="communityTopicForm" [fCN]="'search_filter'" [dataSource]="searchFilterOptions"
                    [placeholder]="'SELECTFILTER' | translate" [icon]="''" [popupWidth]="'auto'">
                </app-form-dropdown>
            </div>
            <!-- No search result text -->
            <div class="pt-1">
                <app-headline [title]="('NOSEARCHRESULTS' | translate)" [type]="'h6'"
                    [class]="'text-center text-secondary'"></app-headline>
            </div>
            <!-- Result text -->
            <div class="d-flex align-items-center gap-1 pt-3">
                <app-headline [title]="'25'" [type]="'h6'" [class]="'text-secondary fw-bold'"></app-headline>
                <app-headline [title]="'results for your search'" [type]="'h6'"
                    [class]="'text-secondary'"></app-headline>
            </div>
        </div>
    </div>

    <div class="custom-scrollbar overflow-y-auto mb-2">
        <div class="card mb-3">
            <div class="card-body p-3">
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center justify-content-end mb-3 gap-2">
                        <app-form-button [text]="'COMMUNITYNEW' | translate" (click)="true" [icon]="'forum'"
                            [iconPosition]="'right'" [cssClass]="'e-primary fw-semibold'"
                            [iconClass]="'fs-5'"></app-form-button>
                        <app-form-button [text]="'COMMUNITYNEWTOPIC' | translate"
                            (click)="onOpenDialog($event, 'show-newtopicdialog')" [icon]="'topic'"
                            [iconPosition]="'right'" [cssClass]="'e-primary fw-semibold'"
                            [iconClass]="'fs-5'"></app-form-button>
                    </div>
                    <div class="d-flex align-items-center">
                        <ejs-breadcrumb [enableNavigation]="false" [maxItems]=2 overflowMode="Menu"
                            [enableActiveItemNavigation]="true">
                            <e-breadcrumb-items>
                                <e-breadcrumb-item iconCss="e-icons e-home mb-1" url="../"></e-breadcrumb-item>
                                <e-breadcrumb-item text="Getting"
                                    url="./breadcrumb/getting-started"></e-breadcrumb-item>
                                <e-breadcrumb-item text="Data-Binding"
                                    url="./breadcrumb/data-binding"></e-breadcrumb-item>
                                <e-breadcrumb-item text="Icons" url="./breadcrumb/icons"></e-breadcrumb-item>
                                <e-breadcrumb-item text="Navigations"
                                    url="./breadcrumb/navigations"></e-breadcrumb-item>
                                <e-breadcrumb-item text="Templates" url="./breadcrumb/templates"></e-breadcrumb-item>
                                <e-breadcrumb-item text="Discover the world of fine arts"
                                    url="./breadcrumb/overflow"></e-breadcrumb-item>
                            </e-breadcrumb-items>
                            <ng-template #separatorTemplate>
                                <app-icon-badge [style]="'default'" [icon]="'chevron_right'" [fontSize]="'fs-5'"
                                    [fontColor]="'text-muted'"></app-icon-badge>
                            </ng-template>
                        </ejs-breadcrumb>
                    </div>


                    <!-- SUB-COMMUNITIES SECTION-->
                    <div class="d-flex flex-column  my-3">
                        <div class="d-flex align-items-center gap-2 flex-wrap">
                            <app-headline [title]="'Sub-communities in: '" [type]="'h6'"
                                [class]="'text-primary fw-bold'"></app-headline>
                            <app-headline [title]="'Name of Parent community'" [type]="'h6'"
                                [class]="'text-muted fw-bold'"></app-headline>
                        </div>
                        <!-- TILES FOR AVAILABLE COMMUNITIES CONTAINER -->
                        <div
                            class="community-tiles d-flex flex-wrap gap-2 justify-content-start align-items-stretch mt-3">

                            <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer ">
                                <div class="card-body p-0">
                                    <!-- Image with icon -->
                                    <div class="position-relative">
                                        <ng-container *ngIf="imageSrc1; else noImage1">
                                            <div class="card-img">
                                                <img [src]="imageSrc1" alt="icon"
                                                    class="me-2 w-100 h-100 object-fit-cover rounded-top"
                                                    appNgSrcImageError>
                                            </div>
                                        </ng-container>
                                        <ng-template #noImage1>
                                            <div
                                                class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                                                <div class="icon-placeholder border">
                                                    <app-icon-badge [style]="'default'" [icon]="'forum'"
                                                        [fontSize]="'fs-3'" [fontColor]="'text-muted'"></app-icon-badge>
                                                </div>
                                            </div>
                                        </ng-template>
                                        <div class="position-absolute top-0 end-0 p-2">
                                            <div
                                                class="bg-white bg-opacity-50 rounded-circle d-flex align-items-center justify-content-center dropdown">
                                                <div data-bs-toggle="dropdown" aria-expanded="false"
                                                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                                    <div class="icon-fix">
                                                        <app-icon-badge [style]="'default'" [icon]="'more_vert'"
                                                            [fontColor]="'text-primary'"
                                                            [fontSize]="'fs-5'"></app-icon-badge>
                                                    </div>
                                                </div>
                                                <ul class="dropdown-menu dropdown-menu-end">
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYEDITCOMMUNITYMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYEDITCOMMUNITYMENU' |
                                                            translate) }}</app-link></li>
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYMANAGEEDITORSMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYMANAGEEDITORSMENU' |
                                                            translate)}} - opens the Create Community->Editor
                                                            Permissions Step</app-link></li>
                                                    <!-- It is opening the Dialog for Manage Writers from communitysd, if no Topic under it the menu is missing -->
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYMANAGEWRITERSMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYMANAGEWRITERSMENU' |
                                                            translate) }}</app-link></li>
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYMANAGESUBSCRIBERSMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYMANAGESUBSCRIBERSMENU' |
                                                            translate) }} - opens the Create Community->Subscriber
                                                            Permissions Step</app-link></li>
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYREPARENTCOMMUNITYMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYREPARENTCOMMUNITYMENU' |
                                                            translate) }}</app-link></li>
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYDELETECOMMUNITYMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYDELETECOMMUNITYMENU' |
                                                            translate) }}</app-link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column p-3">
                                        <!-- Title -->
                                        <div class="d-flex justify-content-center align-items-center mt-1">
                                            <app-headline [title]="'Sports'" [type]="'h6'"
                                                [class]="'fw-bold text-center truncate-text-two-lines'"></app-headline>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer">
                                <div class="card-body p-0">
                                    <!-- Image with icon -->
                                    <div class="position-relative">
                                        <ng-container *ngIf="false; else noImage1">
                                            <div class="card-img">
                                                <img [src]="imageSrc1" alt="icon"
                                                    class="me-2 w-100 h-100 object-fit-cover rounded-top"
                                                    appNgSrcImageError>
                                            </div>
                                        </ng-container>
                                        <ng-template #noImage1>
                                            <div
                                                class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                                                <div class="icon-placeholder border">
                                                    <app-icon-badge [style]="'default'" [icon]="'forum'"
                                                        [fontSize]="'fs-3'" [fontColor]="'text-muted'"></app-icon-badge>
                                                </div>
                                            </div>
                                        </ng-template>
                                        <div class="position-absolute top-0 end-0 p-2">
                                            <div
                                                class="bg-white bg-opacity-50 rounded-circle d-flex align-items-center justify-content-center dropdown">
                                                <div data-bs-toggle="dropdown" aria-expanded="false"
                                                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                                    <div class="icon-fix">
                                                        <app-icon-badge [style]="'default'" [icon]="'more_vert'"
                                                            [fontColor]="'text-primary'"
                                                            [fontSize]="'fs-5'"></app-icon-badge>
                                                    </div>
                                                </div>
                                                <ul class="dropdown-menu dropdown-menu-end">
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYEDITCOMMUNITYMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYEDITCOMMUNITYMENU' |
                                                            translate) }}</app-link></li>
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYMANAGEEDITORSMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYMANAGEEDITORSMENU' |
                                                            translate)}} - opens the Create Community->Editor
                                                            Permissions Step</app-link></li>
                                                    <!-- It is opening the Dialog for Manage Writers from communitysd, if no Topic under it the menu is missing -->
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYMANAGEWRITERSMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYMANAGEWRITERSMENU' |
                                                            translate) }}</app-link></li>
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYMANAGESUBSCRIBERSMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYMANAGESUBSCRIBERSMENU' |
                                                            translate) }} - opens the Create Community->Subscriber
                                                            Permissions Step</app-link></li>
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYREPARENTCOMMUNITYMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYREPARENTCOMMUNITYMENU' |
                                                            translate) }}</app-link></li>
                                                    <li><app-link (click)="true"
                                                            [title]="('COMMUNITYDELETECOMMUNITYMENU' | translate)"
                                                            [style]="'dropdown'">{{ ('COMMUNITYDELETECOMMUNITYMENU' |
                                                            translate) }}</app-link></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column p-3">
                                        <!-- Title -->
                                        <div class="d-flex justify-content-center align-items-center mt-1">
                                            <app-headline [title]="'Food and life'" [type]="'h6'"
                                                [class]="'fw-bold text-center truncate-text-two-lines'"></app-headline>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex mt-4">
                        <div class="d-flex align-items-center gap-2 flex-wrap">
                            <app-headline [title]="'Topics in: '" [type]="'h6'"
                                [class]="'text-primary fw-bold'"></app-headline>
                            <app-headline [title]="'Name of Parent community'" [type]="'h6'"
                                [class]="'text-muted fw-bold'"></app-headline>
                        </div>
                    </div>
                    <div class="d-flex align-items-center gap-2 justify-content-end my-2">
                        <app-form-dropdown [fG]="communityTopicForm" [fCN]="'topic_filter'"
                            [dataSource]="topicFilterOptions" [placeholder]="'SELECTFILTER' | translate"
                            [icon]="'filter_list'" [popupWidth]="'auto'" [cssClass]="'small-filter-dropdown'">
                        </app-form-dropdown>
                    </div>
                    <!-- TILES FOR TOPIC CONTAINER -->
                    <div class="topic-tiles d-flex flex-wrap gap-2 justify-content-start align-items-stretch mb-3">
                        <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer ">
                            <div class="card-body p-0">
                                <!-- Image with icon -->
                                <div class="position-relative">
                                    <ng-container *ngIf="imageSrc; else noImage">
                                        <div class="card-img">
                                            <img [src]="imageSrc" alt="icon"
                                                class="me-2 w-100 h-100 object-fit-cover rounded-top"
                                                appNgSrcImageError>
                                        </div>
                                    </ng-container>
                                    <ng-template #noImage>
                                        <div
                                            class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                                            <div class="icon-placeholder border">
                                                <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-3'"
                                                    [fontColor]="'text-muted'"></app-icon-badge>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <div class="position-absolute top-0 end-0 p-2">
                                        <div
                                            class="bg-white bg-opacity-50 rounded-circle d-flex align-items-center justify-content-center dropdown">
                                            <div data-bs-toggle="dropdown" aria-expanded="false"
                                                [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                                <div class="icon-fix">
                                                    <app-icon-badge [style]="'default'" [icon]="'more_vert'"
                                                        [fontColor]="'text-primary'"
                                                        [fontSize]="'fs-5'"></app-icon-badge>
                                                </div>
                                            </div>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <!-- It is opening the Dialog Edit Writers List from communitysd ???? We need to discuss this!!!-->
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICNOTIFICATIONSETTINGSMENU' | translate)"
                                                        [style]="'dropdown'">{{
                                                        ('COMMUNITYTOPICNOTIFICATIONSETTINGSMENU' | translate)
                                                        }}</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICMARKDISCUSSIONASREADMENU' | translate)"
                                                        [style]="'dropdown'">{{
                                                        ('COMMUNITYTOPICMARKDISCUSSIONASREADMENU' | translate) }} - if
                                                        has unread discussion</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICUNSUBSCRIBEMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYTOPICUNSUBSCRIBEMENU' |
                                                        translate) }}</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYREPARENTTOPICMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYREPARENTTOPICMENU' |
                                                        translate) }}</app-link></li>
                                                <!-- It is opening the Dialog Edit Writers List from communitysd -->
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYMANAGEWRITERSMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYMANAGEWRITERSMENU' |
                                                        translate) }}</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICEDITTOPICMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYTOPICEDITTOPICMENU' |
                                                        translate) }} - if owner</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICDELETETOPICMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYTOPICDELETETOPICMENU' |
                                                        translate) }} - if owner</app-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div
                                        class="position-absolute bottom-0 end-0 m-2 bg-white bg-opacity-75 text-primary px-2 py-0 rounded d-flex align-items-center gap-1">
                                        <span class="mts-icon notranslate fs-6" translate="no">person</span>
                                        <app-content [fontSize]="'fs-small'"
                                            [fontColor]="'text-primary'">256</app-content>
                                    </div>
                                    <div class="position-absolute bottom-0 start-0 m-2 d-flex align-items-center gap-1">
                                        <app-form-button (click)="true" [style]="'e-btn'"
                                            [text]="'COMMUNITYREQUESTTOJOINTOPIC' | translate"
                                            [cssClass]="'btn-link bg-secondary brd-transparent text-white fs-default p-1'"
                                            [iconClass]="'text-white'" [icon]="'lock'"
                                            [iconPosition]="'left'"></app-form-button>
                                    </div>
                                </div>
                                <div class="d-flex flex-column p-3">
                                    <!-- Parent Community Name -->
                                    <div class="d-flex">
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                                            [truncateLines]="1" [fontDecoration]="'fw-bold'">Parent Community
                                            Name</app-content>
                                    </div>
                                    <!-- Title -->
                                    <div class="d-flex jusify-content-start mt-1">
                                        <app-headline [title]="'New hire request which goes max two lines and not more'"
                                            [type]="'h6'" [class]="'fw-bold truncate-text-two-lines'"></app-headline>
                                    </div>
                                    <!-- Description -->
                                    <div class="d-flex flex-grow-1 jusify-content-start mt-2">
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                            [truncateLines]="3">Evaluate management efficiency by completing this
                                            survey, lorem ipsum dolor. Evaluate management efficiency by completing this
                                            survey, lorem ipsum dolor.</app-content>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card p-0 d-flex flex-column p-card rounded cursor-pointer">
                            <div class="card-body p-0">
                                <!-- Image with icon -->
                                <div class="position-relative">
                                    <ng-container *ngIf="false; else noImage">
                                        <div class="card-img">
                                            <img [src]="imageSrc" alt="icon"
                                                class="me-2 w-100 h-100 object-fit-cover rounded-top"
                                                appNgSrcImageError>
                                        </div>
                                    </ng-container>
                                    <ng-template #noImage>
                                        <div
                                            class="card-no-img rounded-top d-flex align-items-center justify-content-center">
                                            <div class="icon-placeholder border">
                                                <app-icon-badge [style]="'default'" [icon]="'topic'" [fontSize]="'fs-3'"
                                                    [fontColor]="'text-muted'"></app-icon-badge>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <div class="position-absolute top-0 end-0 p-2">
                                        <div
                                            class="bg-white bg-opacity-50 rounded-circle d-flex align-items-center justify-content-center dropdown">
                                            <div data-bs-toggle="dropdown" aria-expanded="false"
                                                [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                                <div class="icon-fix">
                                                    <app-icon-badge [style]="'default'" [icon]="'more_vert'"
                                                        [fontColor]="'text-primary'"
                                                        [fontSize]="'fs-5'"></app-icon-badge>
                                                </div>
                                            </div>
                                            <ul class="dropdown-menu dropdown-menu-end">
                                                <!-- It is opening the Dialog Edit Writers List from communitysd ???? We need to discuss this!!!-->
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICNOTIFICATIONSETTINGSMENU' | translate)"
                                                        [style]="'dropdown'">{{
                                                        ('COMMUNITYTOPICNOTIFICATIONSETTINGSMENU' | translate)
                                                        }}</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICMARKDISCUSSIONASREADMENU' | translate)"
                                                        [style]="'dropdown'">{{
                                                        ('COMMUNITYTOPICMARKDISCUSSIONASREADMENU' | translate) }} - if
                                                        has unread discussion</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICUNSUBSCRIBEMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYTOPICUNSUBSCRIBEMENU' |
                                                        translate) }}</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYREPARENTTOPICMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYREPARENTTOPICMENU' |
                                                        translate) }}</app-link></li>
                                                <!-- It is opening the Dialog Edit Writers List from communitysd -->
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYMANAGEWRITERSMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYMANAGEWRITERSMENU' |
                                                        translate) }}</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICEDITTOPICMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYTOPICEDITTOPICMENU' |
                                                        translate) }} - if owner</app-link></li>
                                                <li><app-link (click)="true"
                                                        [title]="('COMMUNITYTOPICDELETETOPICMENU' | translate)"
                                                        [style]="'dropdown'">{{ ('COMMUNITYTOPICDELETETOPICMENU' |
                                                        translate) }} - if owner</app-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div
                                        class="position-absolute bottom-0 end-0 m-2 bg-white bg-opacity-75 text-primary px-2 py-0 rounded d-flex align-items-center gap-1">
                                        <span class="mts-icon notranslate fs-6" translate="no">person</span>
                                        <app-content [fontSize]="'fs-small'"
                                            [fontColor]="'text-primary'">256</app-content>
                                    </div>
                                    <div class="position-absolute bottom-0 start-0 m-2 d-flex align-items-center gap-1">
                                        <app-form-button (click)="true" [style]="'e-btn'"
                                            [text]="'COMMUNITYSUBSCRIBETOPIC' | translate"
                                            [cssClass]="'btn-link bg-bright-yellow brd-transparent text-primary fs-default p-1'"
                                            [iconClass]="'text-primary'" [icon]="'lock_open'"
                                            [iconPosition]="'left'"></app-form-button>
                                    </div>
                                </div>
                                <div class="d-flex flex-column p-3">
                                    <!-- Parent Community Name -->
                                    <div class="d-flex">
                                        <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                                            [truncateLines]="1" [fontDecoration]="'fw-bold'">Parent Community
                                            Name</app-content>
                                    </div>
                                    <!-- Title -->
                                    <div class="d-flex jusify-content-start mt-1">
                                        <app-headline [title]="'New hire request which goes max two lines and not more'"
                                            [type]="'h6'" [class]="'fw-bold truncate-text-two-lines'"></app-headline>
                                    </div>
                                    <!-- Description -->
                                    <div class="d-flex flex-grow-1 jusify-content-start mt-2">
                                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                                            [truncateLines]="3">Evaluate management efficiency by completing this
                                            survey, lorem ipsum dolor. Evaluate management efficiency by completing this
                                            survey, lorem ipsum dolor.</app-content>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="dialogs">
        <!-- Dialog Create New Topic -->
        <ejs-dialog target=".dialogs" class="steps-dialog" [visible]='false' #createNewTopicDialog
            [animationSettings]='dialogService.getAnimationSettings()'
            [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
            [isModal]="true" [allowDragging]="false" [width]="'60%'" [height]="'60vh'" [zIndex]="999"
            [showCloseIcon]="false">
            <ng-template #header class="p-1">
                <app-step-header [steps]="steps" [(activeStep)]="activeStep"></app-step-header>
            </ng-template>
            <ng-template #content>
                <div class="d-flex h-100">
                    <!-- Left Column -->
                    <div class="col-md-4 col-12 d-none d-md-flex flex-column left-container h-100 p-3">
                        <div class="text-center mb-4 pt-m">
                            <app-headline [title]="'COMMUNITYCREATENEWTOPICTITLE' | translate"
                                [type]="'h5'"></app-headline>
                        </div>
                        <app-step-content [steps]="steps" [(activeStep)]="activeStep"></app-step-content>
                        <div class="save-button-container text-center mt-3 d-none d-md-block">
                            <app-form-button [text]="'COMMUNITYTOPICCREATE' | translate"
                                [disabled]="communityTopicForm.invalid" (click)="true"
                                [cssClass]="'e-primary w-100'"></app-form-button>
                        </div>
                    </div>

                    <!-- Right Column -->
                    <div
                        class="col-md-8 col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <div class="d-flex align-items-center">
                                <app-headline [title]="steps[activeStep]" [type]="'h5'"></app-headline>
                                <app-headline *ngIf="activeStep === 4" [title]="'('+('OPTIONALLABEL' | translate) +')'"
                                    [type]="'h6'" [class]="'text-success ms-1'"></app-headline>
                                <div class="ms-2">
                                    <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'"
                                        [text]="('COMMUNITYCREATENEWTOPICHELP' | translate)" [width]="'300px'"
                                        [height]="'100px'" [cssClass]="'helpTooltip p-2'"
                                        [opensOn]="'Click'"></app-tooltip>
                                </div>
                            </div>
                            <app-form-button [style]="'btn'" (click)="onClose('show-newtopicdialog')"
                                [cssClass]="'btn-close'"></app-form-button>
                        </div>

                        <div class="custom-scrollbar overflow-y-auto">
                            <form class="p-1 d-flex flex-column h-100">
                                <ng-container [ngSwitch]="activeStep">
                                    <ng-container *ngSwitchCase="0">
                                        <app-form-label [label]="'COMMUNITYTOPICTITLELABEL' | translate" [maxChars]="70"
                                            [currentChars]="communityTopicForm.controls['community_topic_title'].value.length"></app-form-label>
                                        <app-form-input [placeholder]="('COMMUNITYTOPICTITLEPLACEHOLDER' | translate)"
                                            [label]="('COMMUNITYTOPICTITLEPLACEHOLDER' | translate)"
                                            [errorText]="('COMMUNITYTOPICTITLEREQUIRED' | translate)"
                                            [fCN]="'community_topic_title'" [fG]="communityTopicForm"
                                            [maxChars]="70"></app-form-input>
                                        <app-form-label [label]="'COMMUNITYDESCRIPTIONLABEL' | translate"
                                            [maxChars]="150"
                                            [currentChars]="communityTopicForm.controls['community_topic_description'].value.length"></app-form-label>
                                        <app-form-textarea
                                            [placeholder]="('COMMUNITYDESCRIPTIONPLACEHOLDER' | translate)"
                                            [fCN]="'community_topic_description'" [fG]="communityTopicForm"
                                            [maxChars]="150" [rows]="4"></app-form-textarea>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="1">
                                        SINGLE IMAGE UPLOAD
                                    </ng-container>
                                    <ng-container *ngSwitchCase="2">
                                        User/Group selector
                                    </ng-container>
                                    <ng-container *ngSwitchCase="3">
                                        <app-form-label
                                            [label]="'COMMUNITYVISIBILITYLABEL' | translate"></app-form-label>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <!--Opened - Anyone in the organization can see it. Selected users below will be subscribed automatically.-->
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_topic_visibility'" [value]="0"
                                                    [placeholder]="'COMMUNITYTOPICOPENEDRADIOLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <!--Closed - Only users selected below will be automatically subscribed and able to see it.-->
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_topic_visibility'" [value]="1"
                                                    [placeholder]="'COMMUNITYTOPICCLOSEDRADIOLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <!--ONLY SHOW THIS CONTAINER IF CLOSED TOPIC IS SELECTED-->
                                        <div *ngIf="communityTopicForm.controls['community_topic_visibility'].value === 1"
                                            class="row mb-3 ps-3">
                                            <div class="col-12">
                                                <!--New subscriptions require join request approval-->
                                                <app-form-checkbox [fCN]="'join_by_invite_only'"
                                                    [fG]="communityTopicForm" [cssClass]="'pb-1 lh-base'"
                                                    [labelPosition]="'After'"
                                                    [label]="'COMMUNITYTOPICREQUIRESREQUESTJOINLABEL'"></app-form-checkbox>
                                            </div>
                                        </div>
                                        <app-form-label
                                            [label]="'COMMUNITYTOPICSUBSCRIBERSLABEL' | translate"></app-form-label>
                                        User/Group selector with external email also an icon in the item 'edit_note' to
                                        select writers
                                    </ng-container>
                                    <ng-container *ngSwitchCase="4">
                                        <app-form-label
                                            [label]="'COMMUNITYTOPICDISCUSSIONSSHOWLIKETOLABEL' | translate"></app-form-label>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_likes_visibility'" [value]="0"
                                                    [placeholder]="'COMMUNITYTOPICDISCUSSIONALLSEELIKESLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_likes_visibility'" [value]="1"
                                                    [placeholder]="'COMMUNITYTOPICDISCUSSIONWRITERSSEELIKESLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_likes_visibility'" [value]="1"
                                                    [placeholder]="'COMMUNITYTOPICDISCUSSIONEDITORSSEELIKESLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <app-form-label
                                            [label]="'COMMUNITYTOPICDISCUSSIONSSHOWUSERVIEWSLABEL' | translate"></app-form-label>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_views_visibility'" [value]="0"
                                                    [placeholder]="'COMMUNITYTOPICDISCUSSIONALLSEEUSERVIEWSLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_views_visibility'" [value]="1"
                                                    [placeholder]="'COMMUNITYTOPICDISCUSSIONWRITERSSEEUSERVIEWSLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_views_visibility'" [value]="1"
                                                    [placeholder]="'COMMUNITYTOPICDISCUSSIONEDITORSSEEUSERVIEWSLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <app-form-label
                                            [label]="'COMMUNITYTOPICDISCUSSIONSSHOWFOLLOWERSLABEL' | translate"></app-form-label>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_fallowers_visibility'" [value]="0"
                                                    [placeholder]="'COMMUNITYTOPICDISCUSSIONALLSEEFOLLOWERSLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_fallowers_visibility'" [value]="1"
                                                    [placeholder]="'COMMUNITYTOPICDISCUSSIONWRITERSSEEFOLLOWERSLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-12">
                                                <app-form-radio [fG]="communityTopicForm"
                                                    [fCN]="'community_fallowers_visibility'" [value]="1"
                                                    [placeholder]="'COMMUNITYTOPICDISCUSSIONEDITORSSEEFOLLOWERSLABEL' | translate"
                                                    [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                                            </div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </form>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ejs-dialog>
    </div>
</div>